import datepicker from 'js-datepicker';

//simple datepicker
document.querySelectorAll('form').forEach(form => {
    const datefieldStart = form.querySelector('.js-datePicker-start');
    const datefieldEnd = form.querySelector('.js-datePicker-end');
    let pickerStart, pickerEnd;

    form.querySelectorAll('.js-datePicker').forEach(field => {
        const picker = datepicker(field, {
            minDate: new Date(),
            onShow: inst => toggleArrowsEnabled(inst),
            onMonthChange: inst => toggleArrowsEnabled(inst),
        });
    });

    if (datefieldStart) {
        pickerStart = datepicker(datefieldStart, {
            minDate: new Date(),
            onShow: inst => toggleArrowsEnabled(inst),
            onMonthChange: inst => toggleArrowsEnabled(inst),
            onSelect: (inst, date) => {
                if (pickerEnd) {
                    const minDateEnd = new Date(date.getTime());
                    // minDateEnd.setDate(minDateEnd.getDate() + 1);
                    pickerEnd.setMin(minDateEnd);
                }
            },
        });
    }

    if (datefieldEnd) {
        pickerEnd = datepicker(datefieldEnd, {
            minDate: new Date(),
            onShow: inst => toggleArrowsEnabled(inst),
            onMonthChange: inst => toggleArrowsEnabled(inst),
        });
    }
});

function toggleArrowsEnabled (inst) {
    inst.calendar.querySelector('.qs-left').classList.toggle('disabled', inst.currentMonth <= inst.minDate?.getMonth());
    inst.calendar.querySelector('.qs-right').classList.toggle('disabled', inst.currentMonth >= inst.maxDate?.getMonth());
}
